import {
    getData,
    postData,
} from './Services'

export const getArtDepositoPanel = async (artId,depoId, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`ade_art_id=${encodeURIComponent(artId || '')}`);
    }
    if (depoId) {
        queryParams.push(`ade_depo_id=${encodeURIComponent(depoId || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/artDepositos/articulos_depo_filtros", queryString);
};
  
export const postRealizarInventario = async (body) => {
  const res = await postData('/artDepositos/realizar_inventario', body)
  return res
}
